module.exports = __webpack_public_path__ + "Lato-SemiboldItalic.9fcec04cdba9253e002e.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-SemiboldItalic.woff
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-SemiboldItalic.woff
// module chunks = styles